export default {
  title: 'Zmień dostępność',
  amend_availabilities_form: {
    date: {
      label: 'Wybierz datę',
    },
    times: {
      label: 'Zmiany i godziny otwarcia',
      description:
        'Określ godziny otwarcia dla wybranej daty. Wydłuż, skróć lub zablokuj zmiany. Co najmniej jedna zmiana musi być otwarta.',
      breakfast: {
        label: 'Śniadanie',
      },
      lunch: {
        label: 'Lunch',
      },
      dinner: {
        label: 'Kolacja',
      },
    },
  },
  reason: {
    label: 'Dodaj powód (opcjonalnie)',
    placeholder: 'Wprowadź opis...',
  },
  buttons: {
    save: 'Zapisz',
  },
  projects: {
    online_shop: 'Sklep internetowy',
    reservations: 'Rezerwacje',
    storefront: 'Witryna',
  },
  error_messages: {
    creation_failed: 'Nie udało się utworzyć wyjątku',
  },
};
